import { SubscriptionPlan } from '@lingugeek/schemas';

export const UPGRADE_MESSAGES = {
  [SubscriptionPlan.Free]: {
    title: '🚧 Daily Word Limit Reached',
    message:
      "You've hit the limit for daily words on the Free plan. Unlock unlimited daily words with the Pro plan!",
    upgradeUrl: '/dashboard?upgrade=true&feature=daily_words',
  },
  daily_words: {
    title: '🚧 Daily Word Limit Reached',
    message:
      "You've hit the limit for daily words on the Free plan. Unlock unlimited daily words with the Pro plan!",
    upgradeUrl: '/dashboard?upgrade=true&feature=daily_words',
  },
  max_topics: {
    title: '🚧 Topic Limit Reached',
    message:
      "You've hit the limit for topics on the Free plan. Add more topics with the Pro plan!",
    upgradeUrl: '/dashboard?upgrade=true&feature=topics',
  },
  pronunciation: {
    title: '🔒 Pronunciation Feature Locked',
    message:
      'Pronunciation audio is only available on Pro and Ultra plans. Upgrade to unlock this feature!',
    upgradeUrl: '/dashboard?upgrade=true&feature=pronunciation',
  },
  multi_language_limit: {
    title: '🚧 Language Limit Reached',
    message:
      "You've hit the limit for languages on the Free plan. Learn multiple languages with the Pro plan!",
    upgradeUrl: '/dashboard?upgrade=true&feature=languages',
  },
  custom_delivery_times: {
    title: '🚧 Delivery Time Limit Reached',
    message:
      "You've hit the limit for custom delivery times on the Free plan. Set multiple delivery times with the Pro plan!",
    upgradeUrl: '/dashboard?upgrade=true&feature=delivery_times',
  },
  slang: {
    title: '🔒 Slang Feature Locked',
    message:
      'Slang words are only available on Ultra plan. Upgrade to unlock this feature!',
    upgradeUrl: '/dashboard?upgrade=true&feature=slang',
  },
  funny_facts: {
    title: '🔒 Funny Facts Feature Locked',
    message:
      'Funny facts are only available on Ultra plan. Upgrade to unlock this feature!',
    upgradeUrl: '/dashboard?upgrade=true&feature=funny_facts',
  },
  related_words: {
    title: '🔒 Related Words Feature Locked',
    message:
      'Related words are only available on Pro and Ultra plans. Upgrade to unlock this feature!',
    upgradeUrl: '/dashboard?upgrade=true&feature=related_words',
  },
} as const;

export const GENERAL_UPGRADE_MESSAGE = {
  title: '🚧 Plan Limit Reached',
  message:
    'You\'ve hit a limit for the Free plan 🚧. Unlock full access with the Pro plan → tap "Upgrade".',
  upgradeUrl: '/dashboard?upgrade=true',
} as const;

export function getUpgradeMessage(feature: keyof typeof UPGRADE_MESSAGES) {
  return UPGRADE_MESSAGES[feature];
}

export function getGeneralUpgradeMessage() {
  return GENERAL_UPGRADE_MESSAGE;
}

export const stripeProductToPlan: Record<string, SubscriptionPlan> = {
  prod_Sbo0HlL7lbZEmh: SubscriptionPlan.Free,
  prod_Sbo4zB9xalkCZR: SubscriptionPlan.Pro,
  prod_Sbo66w6VxwPAEz: SubscriptionPlan.Ultra,
};
